import { render, staticRenderFns } from "./modal-gallery.vue?vue&type=template&id=787f58b5&"
import script from "./modal-gallery.vue?vue&type=script&lang=ts&"
export * from "./modal-gallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\references\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787f58b5')) {
      api.createRecord('787f58b5', component.options)
    } else {
      api.reload('787f58b5', component.options)
    }
    module.hot.accept("./modal-gallery.vue?vue&type=template&id=787f58b5&", function () {
      api.rerender('787f58b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal-gallery/modal-gallery.vue"
export default component.exports